import { render, staticRenderFns } from "./dev-tools.page.vue?vue&type=template&id=b6b77c24&"
import script from "./dev-tools.page.vue?vue&type=script&lang=js&"
export * from "./dev-tools.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports